<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemTouchAction} from "@/modules/redactor/models/item/touch/ItemTouchAction";

export default {
  name: "r-item-touch-action",
  props: {
    model: VueTypes.instanceOf(ItemTouchAction),
    label: VueTypes.string.def("Touch Action:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemTouchAction.getValues();
    }
  }
}
</script>